export interface Operator {
  fullName: string;
  user: string;
}

export function createOperator(fullName: string, user: string): Operator {
  return { fullName, user };
}
